export default __webpack_public_path__ + "static/media/new_albert_ai.cce34e7e.svg";